<template>
  <div class="webFooter">
    <!-- <div class="item">
      <img src="../../assets/webImg/layout/address.png" alt="">
      <p>地址：安徽省合肥市望江东路96号</p>
    </div>
    <div class="item">
      <img src="../../assets/webImg/layout/phone.png" alt="">
      <p>电话：0551-82574771、0551-82574459</p>
    </div>
    <div class="item">
      <img src="../../assets/webImg/layout/emails.png" alt="">
      <p>电子邮箱：crec4zp@163.com</p>
    </div> -->
    <div class="recode">
      Copyright © 2024 中国中铁股份有限公司 版权所有 Powered by 中铁信科
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterIndex",
};
</script>


<style lang="less">
.webFooter {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #444444;
  // min-height: 140px;
  height: 40px;
  color: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .item {
    width: 320px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & img {
      width: 18px;
    }
    & p {
      font-size: 14px;
      margin: 0 0 0 6px;
    }
  }
  // width: auto;margin: 10px auto 0;
  .recode {
    text-align: left;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
